import { render, staticRenderFns } from "./AdminPlayground.vue?vue&type=template&id=2ea57a18&scoped=true&"
import script from "./AdminPlayground.vue?vue&type=script&lang=ts&"
export * from "./AdminPlayground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea57a18",
  null
  
)

export default component.exports